import { Component, OnInit } from '@angular/core';
import { IrrService } from './irr.service';
import { environment } from 'src/environments/environment.prod';
@Component({
  selector: 'app-irr',
  templateUrl: './irr.component.html',
  styleUrls: ['./irr.component.scss']
})
export class IrrComponent implements OnInit {
  irrData: any;
  loading: boolean = true;
  email: any;

  constructor(private irrdataservice: IrrService) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.getIrrData();
  }

  getIrrData() {
    this.irrdataservice.getIrrLogData(this.email).subscribe((response) => {
      this.irrData = response["data"];
      console.log("resss", this.irrData);
      this.loading = false;

    });
  }

  redirectToOtherPage(brand_name, nda, dosage) {
    // window.open(`http://localhost:4200/#/settings?brand_name=${brand_name}&nda=${nda}&dosage=${dosage}`, '_blank');
    window.open(`${environment.ip}#/settings?brand_name=${brand_name}&nda=${nda}&dosage=${dosage}`, '_blank');
    // window.open(`http://3.111.249.237/#/settings?brand_name=${brand_name}&nda=${nda}&dosage=${dosage}`, '_blank');
  }

}
